/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { Card, Row, Col, Form, Input, Button, Carousel } from 'antd';
import PropTypes from 'prop-types';
import { UserOutlined } from '@ant-design/icons';

// import 'antd/dist/antd.css';
// import { FORGOT_PASSWORD } from './Constant';
// import { makeSelectForgot } from './selector';
import './style.css';
import { Content } from 'antd/es/layout/layout';
import { useDispatch, useSelector } from 'react-redux';
import { clearDataReguest, forgotPasswordRequest } from './Actions';
import { selectLoading, selectRedirectUrl } from './Selectors';
import CustomSpin from '../CommonSpin';
import { useNavigate } from 'react-router-dom';
// import { ButtonText } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';
import { BodyTextHeading } from '../CommonText';

const CaroRepeat = (props) => {


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    return (
        <div>
            <Card className={props.classname}>
                <div style={{ marginBottom: '100%' }}>
                    <div>
                        <h1
                            style={{
                                color: '#fff',
                                fontSize: 30,
                                fontFamily: 'Roboto',
                                marginTop: '37%',
                            }}
                        >
                            <strong>{langdata.Findtrustedmedicaladvicefrom150000topdoctors ? langdata.Findtrustedmedicaladvicefrom150000topdoctors : 'Find trusted medical advice from 1,50,000 top doctors' }</strong>
                        </h1>
                    </div>
                </div>
            </Card>
        </div>
    );
};

const ForgotPassword = () => {
    const [form] = Form.useForm();  // Use the Form hook from Ant Design
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const requesting = useSelector(selectLoading);
    const url = useSelector(selectRedirectUrl);
    // Handle form submission


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    useEffect(() => {
        dispatch(clearDataReguest());
    },[]);
    const handleSubmit = (e) => {
        // e.preventDefault();
        dispatch(forgotPasswordRequest(e));
    };

    if(url) {
        navigate(url);
    }

    return (
        <Content>
            <div style={{ marginTop: '2%', marginBottom: '2%' }}>
                <Row>
                    {/* <Col> */}
                    <Col
                        xs={{ span: 22, offset: 1 }}
                        md={{ span: 8, offset: 1 }}
                        lg={{ span: 6, offset: 4 }}
                        xl={{ span: 6, offset: 4 }}
                        xxl={{ span: 6, offset: 6 }}
                    >
                        <Card style={{ minHeight: 413 }}>
                            <Col
                                sm={{ span: 24, offset: 0 }}
                                lg={{ span: 24, offset: 0 }}
                                xl={{ span: 22, offset: 1 }}
                                xxl={{ span: 20, offset: 3 }}
                                style={{ marginTop: '20%' }}
                            >
                                <div style={{ marginBottom: '20px' }}>
                                    <BodyTextHeading text={langdata.forgotPassword ? langdata.forgotPassword : 'Forgot Password?'} />
                                </div>
                                <Form onFinish={handleSubmit} form={form}>
                                    <Row style={{display:'flex', justifyContent:'center'}}>
                                        <Col span={24} style={{ marginTop: '5%' }}>
                                            <Form.Item
                                                name="userName"
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: langdata.Pleaseinputyourmailid ? langdata.Pleaseinputyourmailid : 'Please input your mail id!',
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    prefix={<UserOutlined type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                                    style={{ width : '100%'}}
                                                    placeholder={langdata.Enteryouremail ? langdata.Enteryouremail : 'Enter your email'}
                                                    size="large"
                                                    type="email"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col sm={{ span: 22 }}>
                                            <Form.Item>
                                                <Col sm={{ span: 24 }}>
                                                    <Row style={{display:'flex', justifyContent:'center'}}>
                                                        <Col xs={10} sm={8} md={8} lg={8} xl={8}>
                                                            <Button 
                                                                style={{ width: '100%' }} 
                                                                onClick={() => navigate('/login')}
                                                                size="large"
                                                            >
                                                                {`${langdata.Cancel ? langdata.Cancel : 'Cancel' }`}
                                                            </Button>
                                                        </Col>
                                                        <Col xs={1} sm={1} md={1} lg={1} xl={1}>
                                                        &nbsp;</Col>
                                                        <Col xs={10} sm={8} md={8} lg={8} xl={8}>
                                                            <Button
                                                                type="primary"
                                                                size="large"
                                                                htmlType="submit"
                                                                style={{ 
                                                                    width: '100%',
                                                                    whiteSpace: 'normal',
                                                                    //height: 'auto',
                                                                    padding: '4px 8px',
                                                                    lineHeight: '1.2'
                                                                }}
                                                            >
                                                                {`${langdata.Submit ? langdata.Submit : 'Submit'}`}
                                                            </Button>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Card>
                    </Col>
                    <Col
                        xs={{ span: 0 }}
                        md={{ span: 0 }}
                        lg={{ span: 10 }}
                        xl={{ span: 10 }}
                        xxl={{ span: 12 }}
                    >
                        <Carousel autoplay>
                            <CaroRepeat classname="caro1" />
                            <CaroRepeat classname="caro2" />
                            <CaroRepeat classname="caro3" />
                            <CaroRepeat classname="caro4" />
                        </Carousel>
                    </Col>
                    <Col
                        xs={{ span: 0 }}
                        sm={{ span: 0 }}
                        md={{ span: 6 }}
                        lg={{ span: 0 }}
                        xl={{ span: 0 }}
                    >
                        <Card
                            style={{
                                width: 450,
                                border: 0,
                                maxHeight: 412,
                                borderImageRepeat: 'no-repeat',
                                backgroundImage:
                                    'linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ),url("https://www.rd.com/wp-content/uploads/2017/09/02_doctor_Insider-Tips-to-Choosing-the-Best-Primary-Care-Doctor_519507367_Stokkete.jpg")',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                            }}
                        >
                            <div style={{ marginBottom: '100%' }}>
                                <div>
                                    <h1
                                        style={{
                                            color: '#fff',
                                            fontSize: 30,
                                            fontFamily: 'Roboto',
                                            marginTop: '50%',
                                        }}
                                    >
                                        <strong>Find trusted medical advice from 1,50,000 top doctors</strong>
                                    </h1>
                                </div>
                            </div>
                        </Card>
                    </Col>
                    {/* </Col> */}
                </Row>
            </div>
            <CustomSpin spinning = {requesting} />
        </Content>
    );
};

ForgotPassword.propTypes = {
    dispatch: PropTypes.func.isRequired,
    requesting: PropTypes.object,
};

// const mapStateToProps = createSelector(makeSelectForgot(), (requesting) => ({
//   requesting,
// }));

export default ForgotPassword;
